import { Button } from '@calizahq/react-components-v2'
import styled from '@emotion/styled'
import { WorkspaceView } from '@sales-app/context/workspace/workspace.type'
import { getWorkspacePath } from '@sales-app/context/workspace/workspace.util'
import { AgentDashboardPotentialBooking } from '@sales-app/types/AgentDashboard'
import { Status } from '@sales-app/types/PotentialBooking'
import { Link, useNavigate } from 'react-router-dom'

import { Tag } from '@/components'

export const AgentDashboardPotentialBookingColumns = [
  {
    Header: 'Name',
    accessor: 'bookablePerson',
    width: 100,
    maxWidth: 100,
    canResize: false,
    Cell: function Cell({ row }: { row: { original: AgentDashboardPotentialBooking } }) {
      const { id, bookablePerson, bookablePersonType, bookablePersonId } = row.original

      const path = getWorkspacePath({
        view: WorkspaceView.SUMMARY,
        type: bookablePersonType,
        id: bookablePersonId,
        potentialBookingId: id,
      })

      return (
        <div className="route-link ml-auto flex w-full items-center justify-center">
          <Link className="w-full" to={path}>
            <p className="pr-2 font-bold text-p-sm underline">{bookablePerson}</p>
          </Link>
        </div>
      )
    },
  },
  {
    Header: 'Display City',
    accessor: 'displayCity',
    width: 50,
  },
  {
    Header: 'Status',
    accessor: 'potentialBookingStatus',
    width: 50,
    Cell: ({ value }: { value: string }) => {
      return (
        <div className="flex w-full ml-2 items-left justify-left">
          <Tag className={getStatusTagClassName(value)} size="small">
            <div className="flex flex-row w-full">
              <InitialsContainer className={getStatusBubbleClassName(value)} />
              {value}
            </div>
          </Tag>
        </div>
      )
    },
  },
  {
    Header: 'Source',
    accessor: 'potentialBookingSource',
    width: 50,
  },
  {
    Header: 'Type',
    accessor: 'bookablePersonType',
    width: 50,
  },
  {
    accessor: 'id',
    width: 100,
    maxWidth: 100,
    canResize: false,
    Cell: function Cell({ row }: { row: { original: AgentDashboardPotentialBooking } }) {
      const navigate = useNavigate()
      const { id, bookablePersonType, bookablePersonId } = row.original

      const openPotentialBooking = () => {
        const path = getWorkspacePath({
          view: WorkspaceView.POTENTIALBOOKING,
          type: bookablePersonType,
          id: bookablePersonId,
          potentialBookingId: id,
        })

        navigate(path)
      }

      return (
        <div className="flex items-center justify-center">
          <Button className=" bg-text-semantic-success" onClick={openPotentialBooking} size="small">
            View
          </Button>
        </div>
      )
    },
  },
]

const InitialsContainer = styled.div`
  border-radius: 20px;
  align-items: center;
  justify-content: end;
  flex-shrink: 0;
  width: 10px;
  height: 10px;
  margin-right: 8px;
  margin-top: 3px;
`

const getStatusBubbleClassName = (value: string): string => {
  switch (value) {
    case Status.APPLICATION_STARTED: {
      return 'bg-pink-200'
    }
    case Status.NEW: {
      return 'bg-red-200'
    }
    case Status.NEEDS_ACTION:
    case Status.WORKING: {
      return 'bg-orange-300'
    }
    case Status.FOLLOW_UP: {
      return 'bg-yellow-200'
    }
    case Status.REENGAGED: {
      return 'bg-purple-600'
    }
    case Status.AWAITING_RESPONSE:
    case Status.AUTOMATED_FIRST_CONTACT: {
      return 'bg-grey-600'
    }
    default: {
      return 'bg-grey-700'
    }
  }
}

const getStatusTagClassName = (value: string): string => {
  switch (value) {
    case Status.APPLICATION_STARTED: {
      return 'bg-pink-100 text-black text-p-sm rounded-xl'
    }
    case Status.NEW: {
      return 'bg-red-100 text-black text-p-sm rounded-xl'
    }
    case Status.NEEDS_ACTION:
    case Status.WORKING: {
      return 'bg-orange-100 text-black text-p-sm rounded-xl'
    }
    case Status.FOLLOW_UP: {
      return 'bg-yellow-100 text-black text-p-sm rounded-xl'
    }
    case Status.REENGAGED: {
      return 'bg-purple-100 text-black text-p-sm rounded-xl'
    }
    case Status.AWAITING_RESPONSE:
    case Status.AUTOMATED_FIRST_CONTACT: {
      return 'bg-grey-100 text-black text-p-sm rounded-xl'
    }
    default: {
      return 'bg-emphasis text-black text-p-sm rounded-xl'
    }
  }
}
